import React from 'react';

import { AdminListPageRenderer, useAdminListPage } from 'hooks/useAdminListPage';

import { buildPromptListConfig } from '../shared/promptListConfig';

const config = buildPromptListConfig({
  targets: [{ name: 'Workspace', id: 'Summarization' }],
  title: 'Workspace Prompts',
  columnStorageKey: 'admin.workspacePrompts',
  addButtonLabel: 'Add Workspace Prompt',
  archiveObjType: 'Workspace Prompt',
  promptLabel: 'Workspace',
  addPath: '/admin/workspace-prompts/new',
  editPath: (id) => `/admin/workspace-prompts/${id}/edit`,
  copyPath: (id) => `/admin/workspace-prompts/${id}/edit?copy=true`,
  defaultSort: 'updatedAt desc',
  clientFilterQueryKey: 'workspacePrompts',
  searchPlaceholder: 'Search Prompts',
});

export default function WorkspacePrompts() {
  const state = useAdminListPage(config);

  return <AdminListPageRenderer config={config} state={state} />;
}
